// // ContentBlocksList.tsx
// import React from "react";

// import {
//   Button,
//   Box,
//   Typography,
//   Divider,
//   Paper,
// } from "@mui/material";
// import { AddCircleOutline } from "@mui/icons-material";

// import { ContentBlock } from "./TemplateGenerationButton";
// import ContentBlockForm from "./ContentBlockForm";

// interface ContentBlocksListProps {
//   blocks: ContentBlock[];
//   setBlocks: (blocks: ContentBlock[]) => void;
//   disabled?: boolean;
//   isSpartan?: boolean;
// }

// /**
//  * Renderiza una lista de bloques con su respectivo sub-formulario
//  * y provee botones para agregar y eliminar bloques.
//  */
// const ContentBlocksList: React.FC<ContentBlocksListProps> = ({
//   blocks,
//   setBlocks,
//   disabled,
//   isSpartan
// }) => {
//   const handleAddBlock = () => {
//     setBlocks([
//       ...blocks,
//       {
//         type: "",
//         content: "",
//         image: "",

//         videoUrl: "",
//         alignment: "",
//         quote: "",
//       } as any,
//     ]);
//   };


//   console.log("blocks 1", [...blocks]);


//   const handleRemoveBlock = (index: number) => {

//     const newBlocks = blocks.filter((_, i) => i !== index);
//     setBlocks(newBlocks);
//   };

//   const handleChangeBlock = (updatedBlock: ContentBlock, index: number) => {
//     const newBlocks = [...blocks];
//     newBlocks[index] = updatedBlock;
//     setBlocks(newBlocks);
//   };

//   // 1) Añade una función para cambiar el bloque de posición:
//   const handleReorderBlock = (oldIndex: number, newIndex: number) => {
//     // Evitamos posiciones inválidas
//     if (newIndex < 0 || newIndex >= blocks.length) return;

//     const updatedBlocks = [...blocks];
//     const [movedBlock] = updatedBlocks.splice(oldIndex, 1);
//     updatedBlocks.splice(newIndex, 0, movedBlock);
//     setBlocks(updatedBlocks);
//   };

//   return (
//     <Box>


//       {/* Lista de Bloques de Contenido */}
//       {blocks.length === 0 ? (
//         <Typography variant="body1" color="textSecondary">
//           No hay bloques de contenido agregados.
//         </Typography>
//       ) : (
//         blocks.map((block, index) => (
//           <ContentBlockForm
//             key={block?.id || index}
//             index={index}
//             block={block}
//             onChange={handleChangeBlock}
//             onRemove={handleRemoveBlock}
//             onReorder={handleReorderBlock}
//             maxPosition={blocks.length}
//             disabled={disabled}
//             isSpartan={isSpartan}
//           />
//         ))
//       )}

//       {/* Botón para Agregar Nuevo Bloque de Contenido */}
//       {!disabled && (
//         <Box display="flex" justifyContent="center" mt={4}>
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleAddBlock}
//             startIcon={<AddCircleOutline />}
//             sx={{
//               textTransform: "none",
//               paddingX: 4,
//               paddingY: 1.5,
//               fontSize: "1rem",
//               borderRadius: 2,
//             }}
//           >
//             Agregar Bloque de Contenido
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default ContentBlocksList;


import React, { useCallback } from "react";
import { Box, Button, Typography } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";
import { ContentBlock } from "./TemplateGenerationButton";
import ContentBlockForm from "./ContentBlockForm";

interface ContentBlocksListProps {
  blocks: ContentBlock[];
  setBlocks: (blocks: ContentBlock[]) => void;
  disabled?: boolean;
  isSpartan?: boolean;
}

/**
 * Renderiza una lista de bloques con su respectivo sub-formulario
 * y provee botones para agregar y eliminar bloques.
 */
const ContentBlocksList: React.FC<ContentBlocksListProps> = ({
  blocks,
  setBlocks,
  disabled = false,
  isSpartan = false,
}) => {
  const handleAddBlock = useCallback(() => {
    setBlocks([
      ...blocks,
      {
        type: "",
        content: "",
        image: "",
        videoUrl: "",
        alignment: "",
        quote: "",
      } as any,
    ]);
  }, [blocks, setBlocks]);

  const handleRemoveBlock = useCallback(
    (index: number) => {
      setBlocks(blocks.filter((_, i) => i !== index));
    },
    [blocks, setBlocks]
  );

  const handleChangeBlock = useCallback(
    (updatedBlock: ContentBlock, index: number) => {
      const newBlocks = [...blocks];
      newBlocks[index] = updatedBlock;
      setBlocks(newBlocks);
    },
    [blocks, setBlocks]
  );

  const handleReorderBlock = useCallback(
    (oldIndex: number, newIndex: number) => {
      if (newIndex < 0 || newIndex >= blocks.length) return;
      const updatedBlocks = [...blocks];
      const [moved] = updatedBlocks.splice(oldIndex, 1);
      updatedBlocks.splice(newIndex, 0, moved);
      setBlocks(updatedBlocks);
    },
    [blocks, setBlocks]
  );

  return (
    <Box>
      {/* Lista de Bloques de Contenido */}
      {blocks.length === 0 ? (
        <Typography variant="body1" color="textSecondary">
          No hay bloques de contenido agregados.
        </Typography>
      ) : (
        blocks.map((block, index) => (
          <ContentBlockForm
            key={block.id ?? index}
            index={index}
            block={block}
            onChange={handleChangeBlock}
            onRemove={handleRemoveBlock}
            onReorder={handleReorderBlock}
            maxPosition={blocks.length}
            disabled={disabled}
            isSpartan={isSpartan}
          />
        ))
      )}

      {/* Botón para Agregar Nuevo Bloque de Contenido */}
      {!disabled && (
        <Box display="flex" justifyContent="center" mt={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddBlock}
            startIcon={<AddCircleOutline />}
            sx={{
              textTransform: "none",
              px: 4,
              py: 1.5,
              fontSize: "1rem",
              borderRadius: 2,
            }}
          >
            Agregar Bloque de Contenido
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default React.memo(ContentBlocksList);
